import { TrendingUp, FileCheck, Target, CheckCircle2 } from 'lucide-react';

export function MetricsBar({ stats }) {
  const safeStats = stats || {
    total_cases: 0,
    completed_cases: 0,
    avg_score: 0,
    remaining_cases: 0,
    session_credits: 0,
    session_credits_used: 0,
  };

  const remainingCredits = Math.max(0, safeStats.session_credits - safeStats.session_credits_used);
  const completionPercentage = safeStats.total_cases > 0 
    ? Math.round((safeStats.completed_cases / safeStats.total_cases) * 100) 
    : 0;

  return (
    <div className="relative mb-8">
      {/* Credits Badge */}
      <div className="absolute -top-3 right-4 z-10 flex items-center gap-1.5 px-3 py-1 bg-violet-100 text-violet-700 text-xs font-bold uppercase tracking-wider rounded-full shadow-sm border border-violet-200">
        <Target className="w-3.5 h-3.5" />
        Session Credits: {remainingCredits} remaining
      </div>

      <div className="grid grid-cols-1 md:grid-cols-4 gap-4">
        <MetricCard 
          title="Total Cases" 
          value={safeStats.total_cases} 
          subtitle="assigned to you" 
          icon={<FileCheck className="w-5 h-5 text-blue-500" />} 
          trend="primary"
        />
        <MetricCard 
          title="Completed Cases" 
          value={safeStats.completed_cases} 
          subtitle={`${completionPercentage}% done`} 
          icon={<CheckCircle2 className="w-5 h-5 text-violet-500" />} 
          trend="positive"
        />
        <MetricCard 
          title="Average Score" 
          value={`${safeStats.avg_score}%`} 
          subtitle="across completed" 
          icon={<TrendingUp className="w-5 h-5 text-amber-500" />} 
          trend="warning"
        />
        <MetricCard 
          title="Remaining Cases" 
          value={safeStats.remaining_cases} 
          subtitle="cases to go" 
          icon={<Target className="w-5 h-5 text-indigo-500" />} 
          trend="neutral"
        />
      </div>
    </div>
  );
}

function MetricCard({ title, value, subtitle, icon, trend }) {
  const trendStyles = {
    primary: 'bg-blue-50 border-blue-100',
    positive: 'bg-violet-50 border-violet-100',
    warning: 'bg-amber-50 border-amber-100',
    neutral: 'bg-indigo-50 border-indigo-100',
  };

  return (
    <div className={`p-4 rounded-2xl border ${trendStyles[trend]} flex items-center justify-between`}>
      <div>
        <p className="text-xs font-semibold text-slate-500 uppercase tracking-wider mb-1">{title}</p>
        <div className="flex items-baseline gap-2">
          <h3 className="text-2xl font-bold text-slate-800">{value}</h3>
          <span className="text-xs font-medium text-slate-500">{subtitle}</span>
        </div>
      </div>
      <div className="p-3 bg-white rounded-xl shadow-sm border border-white">
        {icon}
      </div>
    </div>
  );
}
